var _circle, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 15.5,
    fill: "#F2F4F7",
    stroke: "url(#paint0_linear_1534_57607)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.9297,
    y: 10.2812,
    width: 2.85714,
    height: 11.3143,
    fill: "url(#paint1_linear_1534_57607)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2148,
    y: 10.2812,
    width: 2.85714,
    height: 11.3143,
    fill: "url(#paint2_linear_1534_57607)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1534_57607",
    x1: 6.1,
    y1: 29.2,
    x2: 32.5,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#3FC36D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1534_57607",
    x1: 12.4297,
    y1: 20.6055,
    x2: 15.3299,
    y2: 20.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#3FC36D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1534_57607",
    x1: 18.7148,
    y1: 20.6055,
    x2: 21.615,
    y2: 20.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E49A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#3FC36D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaying);
export default __webpack_public_path__ + "static/media/Playing.26e10ac7c27af41dd9d5e0b13db69834.svg";
export { ForwardRef as ReactComponent };